// Kept apart from procedures/index so low-level modules (performed-by) can use
// it without importing the procedure domain.
export var SystemProcedure;
(function (SystemProcedure) {
    SystemProcedure["CreditorEndedCase"] = "CREDITOR_ENDED_CASE";
    SystemProcedure["EndCase"] = "END_CASE";
    SystemProcedure["Overpayment"] = "OVERPAYMENT";
    SystemProcedure["RemainderReminder"] = "REMAINDER_REMINDER";
    SystemProcedure["EndCaseAccord"] = "END_CASE_ACCORD";
    SystemProcedure["PrincipalPayment"] = "PRINCIPAL_PAYMENT";
    SystemProcedure["PaymentOnCourtCase"] = "PAYMENT_ON_COURT_CASE";
    SystemProcedure["Update"] = "UPDATE";
    SystemProcedure["InteractionSentToDebtor"] = "INTERACTION_SENT_TO_DEBTOR";
    SystemProcedure["CaseStatusChange"] = "CASE_STATUS_CHANGE";
    SystemProcedure["ObjectionOnRelatedCase"] = "OBJECTION_ON_RELATED_CASE";
    SystemProcedure["EmailJournalized"] = "EMAIL_JOURNALIZED";
    SystemProcedure["CourtEmailJournalized"] = "COURT_EMAIL_JOURNALIZED";
    SystemProcedure["PaymentPlanInitial"] = "PAYMENT_PLAN_INITIAL";
    SystemProcedure["PaymentPlanDocumentSigned"] = "PAYMENT_PLAN_DOCUMENT_SIGNED";
    SystemProcedure["PaymentPlanReminder"] = "PAYMENT_PLAN_REMINDER";
    SystemProcedure["PaymentPlanPayment"] = "PAYMENT_PLAN_PAYMENT";
    SystemProcedure["PaymentPlanAutoPaymentFailure"] = "PAYMENT_PLAN_AUTO_PAYMENT_FAILURE";
    SystemProcedure["PaymentPlanBSLSSubmitFailed"] = "PAYMENT_PLAN_BS_LS_SUBMIT_FAILED";
    SystemProcedure["PaymentPlanBSLSRejected"] = "PAYMENT_PLAN_BS_LS_REJECTED";
    SystemProcedure["PaymentPlanBSLSAgreementCancelled"] = "PAYMENT_PLAN_BS_LS_AGREEMENT_CANCELLED";
    SystemProcedure["PaymentPlanDeadline"] = "PAYMENT_PLAN_DEADLINE";
    SystemProcedure["PaymentPlanCanceled"] = "PAYMENT_PLAN_CANCELED";
    SystemProcedure["PaymentPlanTwoHourActivationReminder"] = "PAYMENT_PLAN_TWO_HOUR_ACTIVATION_REMINDER";
    SystemProcedure["PaymentPlanOneDayActivationReminder"] = "PAYMENT_PLAN_ONE_DAY_ACTIVATION_REMINDER";
    SystemProcedure["PaymentPlanThreeDayActivationReminder"] = "PAYMENT_PLAN_THREE_DAY_ACTIVATION_REMINDER";
    SystemProcedure["CancelUnactivatedPaymentPlansAfterActivationDeadline"] = "CANCEL_UNACTIVATED_PAYMENT_PLANS_AFTER_ACTIVATION_DEADLINE";
    SystemProcedure["PaymentPlanCreationByCaseworker"] = "PAYMENT_PLAN_CREATION_BY_CASEWORKER";
    SystemProcedure["BankAccountDetailsApprovalRefund"] = "BANK_ACCOUNT_DETAILS_APPROVAL_REFUND";
    SystemProcedure["DebtExpires"] = "DEBT_EXPIRES";
    SystemProcedure["DebtorCanBeRegisteredInDebtRegister"] = "DEBTOR_CAN_BE_REGISTERED_IN_DEBT_REGISTER";
    SystemProcedure["DebtorIsUnderage"] = "DEBTOR_IS_UNDERAGE";
    SystemProcedure["Address"] = "ADDRESS";
    SystemProcedure["Active"] = "ACTIVE";
    SystemProcedure["Dead"] = "DEAD";
    SystemProcedure["Disappeared"] = "DISAPPEARED";
    SystemProcedure["MovedAbroad"] = "MOVED_ABROAD";
    SystemProcedure["Homeless"] = "HOMELESS";
    SystemProcedure["CompanyActive"] = "COMPANY_ACTIVE";
    SystemProcedure["Inactive"] = "INACTIVE";
    SystemProcedure["OperationsCeased"] = "OPERATIONS_CEASED";
    SystemProcedure["AddressProtection"] = "ADDRESS_PROTECTION";
    SystemProcedure["NewRKIRegristration"] = "NEW_RKI_REGISTRATION";
    SystemProcedure["DeletedRKIRegistration"] = "DELETED_RKI_REGISTRATION";
    SystemProcedure["DeletedRKIRegistrationWillingnessToPay"] = "DELETED_RKI_REGISTRATION_WILLINGNESS_TO_PAY";
    SystemProcedure["GuardianStatus"] = "GUARDIAN_STATUS";
    SystemProcedure["DissolutionStatus"] = "DISSOLUTION_STATUS";
    SystemProcedure["BOBEHANDLING"] = "BOBEHANDLING";
    SystemProcedure["AKSFailed"] = "AKS_FAILED";
    SystemProcedure["NewAsset"] = "NEW_ASSET";
    SystemProcedure["NewLien"] = "NEW_LIEN";
    SystemProcedure["AssetChanged"] = "ASSET_CHANGED";
    SystemProcedure["LienChanged"] = "LIEN_CHANGED";
    SystemProcedure["AssetRemoved"] = "ASSET_REMOVED";
    SystemProcedure["LienRemoved"] = "LIEN_REMOVED";
})(SystemProcedure || (SystemProcedure = {}));
//# sourceMappingURL=system.js.map